document.querySelectorAll('.opinions').forEach((block) => {
    const open = block.querySelector('.js-open-video');
    const modal = block.querySelector('.opinions__overlay');
    const video = block.querySelector('.opinions__media');
    const close = modal ? modal.querySelector('.close') : null;
    const frame = modal ? modal.querySelector('iframe') : null;

    if (!open || !modal || !close || !frame) return;

    open.addEventListener('click', () => {
        const base = open.dataset.video;
        if (!base) return;
        const src = base.includes('?') ? base + '&autoplay=1' : base + '?autoplay=1';
        frame.src = src;
        modal.classList.add('active');
        video.classList.add('active');
        document.body.classList.add('video-open');

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        block._preventScroll = (e) => e.preventDefault();
        document.addEventListener('touchmove', block._preventScroll, { passive: false, capture: true });
    });

    function closeVideo() {
        frame.src = '';
        modal.classList.remove('active');
        video.classList.remove('active');
        document.body.classList.remove('video-open');

        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        if (block._preventScroll) {
            document.removeEventListener('touchmove', block._preventScroll, { capture: true });
            block._preventScroll = null;
        }
    }

    close.addEventListener('click', closeVideo);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeVideo(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeVideo(); });
});
